import { Reducer } from 'redux'
import { FoldersState } from './types'
import { ActionTypes } from './constants'

export const initialState: FoldersState = {
  currentFolders: [],
  id: null,
}

export const foldersReducer: Reducer<FoldersState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_FOLDERS:
      return {
        ...state,
        currentFolders: action.payload,
      }
    case ActionTypes.SET_FOLDERS_ID:
      return {
        ...state,
        id: action.payload.id,
      }
    case ActionTypes.CREATE_PROJECT_SUCCESS:
      return {
        ...state,
        id: null,
      }
    default:
      return state
  }
}

export default foldersReducer
